/* eslint no-shadow: "off" */

export default () => ({
    categories: [],
    classifications: [],
    workTypes: [],
    brand: {},
    brandArticles: [],
    brandArticleDetails: [],
    searchFilterCount: 0,
    emitSearchFilterCount: 0,
    searchTag: 0,
    searchPayload: {
        search_filters: {},
    },
    initSearchCriteria: {
        applyflow_custom_1:[],
        applyflow_custom_2:[],
        applyflow_custom_3:[],
        applyflow_custom_4:[],
        classifications: [],
        location: {},
        page: 1,
        pay_min: {},
        pay_max: {},
        search_keywords: '',
        sort_by: '',
    },
    adType: [
        {
            id: 1,
            name: 'Private listings',
            slug: 'private-listings',
            is_selected: false,
            count: '',
        },
        {
            id: 2,
            name: 'Recruiters',
            slug: 'recruiters',
            is_selected: false,
            count: '',
        },
    ],
    postedWithIn: [
        {
            days: 0,
            value: 'Any time',
            is_selected: true,
            count: '',
        },
        {
            days: 1,
            value: 'Today',
            is_selected: false,
            count: '',
        },
        {
            days: 7,
            value: '7 days',
            is_selected: false,
            count: '',
        },
        {
            days: 30,
            value: '30 days',
            is_selected: false,
            count: '',
        },
    ],
    searchFilterAttributes: [],
    searchFilterTags: [],
    searchbarTagsHide: true,
    activeSearchFilter: false,
    searchEditMode: false,
    jobAlertModeNew: false,
    jobAlertModeUpdate: false,
    jobAlertUpdateId: null,
    salaries: [],
    searchPageTemplate: '',
    initSearchData: false,
    isSavedSearchFlyEnabled: true,
    mapView: {
        total: 0,
    },
    loading:  {
        jobs: true,
    },
});
